import { render, staticRenderFns } from "./FormSubmissionResult.vue?vue&type=template&id=235ec960&scoped=true&"
import script from "./FormSubmissionResult.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionResult.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionResult.vue?vue&type=style&index=0&id=235ec960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ec960",
  null
  
)

export default component.exports